<script setup lang="ts">

</script>

<template>
    <v-card
        variant="flat"
        class="mt-5 rounded-lg"
        style="border: 1px solid hsla(210,18%,87%,1) !important"
    >
        <v-card-text class="text-center black--text">
            <slot />
        </v-card-text>
    </v-card>
</template>

<style scoped>

</style>
